import parse, { Element } from 'html-react-parser';
import type { DOMNode } from 'html-react-parser';
import Markdown from 'react-markdown';
import { Wrapper } from './ContentParser.styles';
import type { ContentParserProps } from './ContentParser.types';

const HTML_TAG_REGEX = /<\/?[a-z][\s\S]*>/i;
const UNSAFE_TAGS = new Set(['script', 'iframe', 'object', 'embed', 'link', 'style']);
const EVENT_ATTR_REGEX = /^on/i;

function sanitizeNode(node: DOMNode) {
  if (!(node instanceof Element)) return;
  if (UNSAFE_TAGS.has(node.name)) return <></>;

  // Strip event handler attributes and javascript: URLs
  for (const attr of Object.keys(node.attribs)) {
    if (EVENT_ATTR_REGEX.test(attr)) {
      delete node.attribs[attr];
    }
    if (attr === 'href' || attr === 'src' || attr === 'action') {
      if (node.attribs[attr]?.trim().toLowerCase().startsWith('javascript:')) {
        delete node.attribs[attr];
      }
    }
  }
}

export function ContentParser({ text = '', className }: ContentParserProps) {
  if (!text) return null;

  const containsHtml = HTML_TAG_REGEX.test(text);

  if (containsHtml) {
    return <Wrapper className={className}>{parse(text, { replace: sanitizeNode })}</Wrapper>;
  }

  return (
    <Wrapper className={className}>
      <Markdown>{text}</Markdown>
    </Wrapper>
  );
}
